<template>
    <div class="views-content--visualizer-landing">

        <!-- Banner -->
        <banner-generic
            :data="data.hero"
            :isContentInside="true"
            :preText="data.hero.pretext"
        />

        <!--
        <div class="padding--lg">
            <element-text v-if="data.text" :data="data.text" />
        </div>
        -->

        <!-- Select house type section -->
        <section class="space--md">
            <div class="container">
                <div class="row">
                    <div class="card-wrapper col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" v-for="(house, index) in data.houses" :key="index" >
                        <a :href="house.visualiserlink" class="card card--profile"
                        data-category="Roof Visualiser" data-action="Click" :data-label="house.title"
                        >
                            <div class="card-image">
                                <img class="house-image" alt="house.title" v-lazy="house.image" >
                            </div>
                            <div class="card-body">
                                <h4 class="medium">{{house.title}}</h4>
                                <img
                                    src="/_resources/themes/colorsteel/dist/assets/images/icons/arrow-right-icon.svg"
                                    alt="arrow icon"
                                    class="icon-arrow"
                                />
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </section>

        <section v-if="data.footer.title || data.footer.content || data.footer.cta">
            <div class="container">
                <div class="row">
                    <div class="footer col-xs-12">
                        <h2 v-if="data.footer.title" class="text-center no--margin">
                            {{ data.footer.title}}
                        </h2>
                        <div v-if="data.footer.content" v-html="data.footer.content" class="wysiwyg-content text-center no--margin"></div>
                        <a
                            v-if="data.footer.cta && data.footer.cta.label"
                            class="button button--solid-black no--margin"
                            :href="data.footer.cta.link"
                            :target="data.footer.cta.openInNewWindow ? '_blank' : null"
                            data-category="Roof Visualiser" data-action="Click" :data-label="data.footer.cta.label"
                        >
                            {{ data.footer.cta.label }}
                        </a>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>

import {
    BannerGeneric,
    // ElementText
} from "../components";

export default {
    name: "v-visualiser-landing",
    components: {
        BannerGeneric,
        // ElementText
    },
    props: {
        data: {
            type: Object
        }
    },
    data () {
        return {}
    },
    mounted () {

    }
};
</script>

<style lang="scss" scoped>
@import "../../scss/abstracts/variables";

.house-image{
    aspect-ratio: 16/9;
    object-fit: cover;
    z-index: 0;
}

.card-wrapper {
    padding-bottom: 3rem;
}

.card--profile {
    display: block;
    margin-bottom: 0;
    border-bottom: 1px solid #000;
    height: 100%;
    
    .card-image {
        position: relative;
        margin-bottom: 0;

        &::before {
            content: "";
            display: block;
            position: absolute;
            z-index: 3;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: white;
            transition: all 300ms;
            opacity: 0;
        }
    }

    .card-body {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px 0;
        gap: 8px;
        
        h4 {
            font-weight: 500;
        }
    }

    .icon-arrow {
        transition: transform 250ms ease-in-out;
    }

    &:hover {
        .card-image {
            &::before {
                opacity: 0.2;
            }
        }

        .icon-arrow {
            transform: translateX(5px);
        }
    }

    h4 {
        margin: 0;
    }
}

.footer {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding-top: 40px;
    padding-bottom: 40px;

    @media #{$md} {
        align-items: center;
    }

    .wysiwyg-content {
        > :first-child {
            margin-top: 0;
        }

        > :last-child {
            margin-bottom: 0;
        }
    }
}

</style>

